// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles_buttonWrapper__z28on","searchSummary":"styles_searchSummary__SihdD"};